/**
 * API配置文件 - 统一管理API基础URL
 */

// API基础URL - 智能检测运行环境 (v2.0 - 修复缓存问题)
function getApiBaseUrl(): string {
  // 如果是通过Workers访问（8788端口），使用相对路径通过Worker代理
  if (typeof window !== 'undefined' && window.location.port === '8788') {
    console.log('🔧 API配置: 使用Worker代理模式 (8788端口)');
    return '';  // 相对路径，通过Frontend Worker代理到8787端口
  }
  
  // 如果是传统开发模式（5174端口），使用本地API
  if (typeof window !== 'undefined' && window.location.port === '5174') {
    console.log('🔧 API配置: 使用传统开发模式 (5174端口)');
    return 'http://localhost:8787';
  }
  
  // 生产环境或其他情况，使用环境变量或生产API
  console.log('🔧 API配置: 使用生产环境模式');
  return import.meta.env.VITE_API_URL || 'https://prompt-master-api-production.testprompt428.workers.dev';
}

export const API_BASE_URL = getApiBaseUrl();

// API端点配置
export const API_ENDPOINTS = {
  // 认证相关
  AUTH: {
    LOGIN: '/api/v1/auth/login',
    REGISTER: '/api/v1/auth/register',
    LOGOUT: '/api/v1/auth/logout',
    VERIFY_EMAIL: '/api/v1/auth/verify-email',
    RESET_PASSWORD: '/api/v1/auth/reset-password',
    REFRESH: '/api/v1/auth/refresh',
  },
  
  // 用户相关
  USER: {
    PROFILE: '/api/v1/me',
    PROMPTS: '/api/v1/me/prompts',
  },
  
  // 管理员相关
  ADMIN: {
    USERS: '/api/v1/admin/users',
    USER_STATS: '/api/v1/admin/users/stats',
    INVITATIONS: '/api/v1/admin/invitations',
    INVITATION_STATS: '/api/v1/admin/invitations/stats',
  },
  
  // 系统相关
  SYSTEM: {
    HEALTH: '/api/v1/health',
  },
} as const;

/**
 * 构建完整的API URL
 * @param endpoint API端点路径
 * @returns 完整的API URL
 */
export function buildApiUrl(endpoint: string): string {
  return `${API_BASE_URL}${endpoint}`;
}

/**
 * 获取当前API基础URL
 * @returns API基础URL
 */
export function getCurrentApiBaseUrl(): string {
  return API_BASE_URL;
} 